// src/domains/subs.keys.ts —— 模板键归属（TD-823，agent-keys 用例按片 owner 推导核对）
// subPrices / modal.isSubPrices 来自片 0190 的 A-03 偏差块（0045：原调整费率弹层改为下级售价只读弹层）
export const KEYS = [
  'closeConfirm', 'confirmLabel', 'confirmOpen', 'createSub', 'doConfirm', 'form', 'formError', 'notSubPwd', 'onForm', 'onPwd', 'pwd', 'savePwd',
  'subPrices',
] as const;
export const MODAL_KEYS = ['isMyPwd', 'isNewSub', 'isSubPrices'] as const;
